import React, { useState } from 'react';
import APP_CONFIG from '../config/appConfig';

const GalleryItem = ({ item, onClick, isEditMode = false, onEdit, onDelete }) => {
  const [imageError, setImageError] = useState(false);
  const [videoError, setVideoError] = useState(false);
  const baseServerUrl = APP_CONFIG.getBaseServerUrl();

  const handleImageError = () => {
    setImageError(true);
  };

  const handleVideoError = () => {
    setVideoError(true);
  };

  return (
    <div 
      className="relative group cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border-2 border-gray-400"
      style={{ boxShadow: '0 0 15px rgba(156, 163, 175, 0.5), 0 0 30px rgba(156, 163, 175, 0.3)' }}
      onClick={() => onClick(item)}
    >
      <div className="aspect-w-1 aspect-h-1">
        {item.mediaType === 'video' ? (
          videoError ? (
            <div className="w-full h-64 bg-gradient-to-br from-primary-400 to-secondary-500 flex items-center justify-center">
              <div className="text-center text-white">
                <svg className="w-12 h-12 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z"/>
                </svg>
                <p className="text-sm font-medium">Video Preview</p>
              </div>
            </div>
          ) : (
            <video
              src={item.mediaUrl ? (item.mediaUrl.startsWith('http') ? item.mediaUrl : `${baseServerUrl}${item.mediaUrl}`) : ''}
              poster={item.thumbnail ? (item.thumbnail.startsWith('http') ? item.thumbnail : `${baseServerUrl}${item.thumbnail}`) : ''}
              preload="metadata"
              muted
              loop
              playsInline
              className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
              onMouseEnter={(e) => e.target.play()}
              onMouseLeave={(e) => e.target.pause()}
              onError={handleVideoError}
            />
          )
        ) : (
          imageError ? (
            <div className="w-full h-64 bg-gradient-to-br from-green-400 to-blue-500 flex items-center justify-center">
              <div className="text-center text-white">
                <svg className="w-12 h-12 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
                <p className="text-sm font-medium">{item.title}</p>
              </div>
            </div>
          ) : (
            <img
              src={item.mediaUrl ? (item.mediaUrl.startsWith('http') ? item.mediaUrl : `${baseServerUrl}${item.mediaUrl}`) : ''}
              alt={item.title}
              loading="lazy"
              className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
              onError={handleImageError}
            />
          )
        )}
      </div>
      <div className="absolute top-2 right-2">
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
          item.mediaType === 'video'
            ? 'bg-red-500 text-white' 
            : 'bg-blue-500 text-white'
        }`}>
          {item.mediaType === 'video' ? 'Video' : 'Image'}
        </span>
      </div>

          <div className={`absolute inset-0 bg-black ${isEditMode ? 'bg-opacity-50' : 'bg-opacity-0 group-hover:bg-opacity-30'} transition-all duration-300 flex items-center justify-center`}>
            <div className={`${isEditMode ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'} transition-opacity duration-300 text-center text-white`}>
              <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
              <div className="flex items-center justify-center space-x-2">
                <p className="text-sm">{item.category}</p>
              </div>
              {isEditMode && (
                <div className="mt-4 flex space-x-2 justify-center">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      if (onEdit) {
                      onEdit(item);
                      }
                    }}
                    className="bg-blue-600 text-white px-4 py-2 rounded text-sm hover:bg-blue-700 transition-colors z-10"
                  >
                    Edit
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      if (onDelete) {
                        const itemId = item._id || item.id;
                        onDelete(itemId);
                      }
                    }}
                    className="bg-red-600 text-white px-4 py-2 rounded text-sm hover:bg-red-700 transition-colors z-10"
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          </div>
    </div>
  );
};

export default GalleryItem;
